import { SubmissionStepType } from "generated-graphql/graphql";
import { useWasteStepper } from "hooks/useWasteStepper";
import { Navigate } from "react-router-dom";
import { WASTE_SUBMISSION_STEP_PRESENTATION } from "util/wasteSubmissionStepMetadata";

import { StepperOverview } from "./StepperOverview";

/**
 * The stepper's index (empty-slug) route. Flows with an Overview step (the
 * 8700-12) land on it; flows without one (document forms) redirect to their
 * first step, so the index is never a dead end. The shell renders skeletons
 * until the submission resolves, so `stepperSteps` is always present here.
 */
export function StepperIndexRoute() {
  const { submission } = useWasteStepper();
  const steps = (submission?.stepperSteps ?? []).map(({ step }) => step);

  if (steps.includes(SubmissionStepType.Overview)) {
    return <StepperOverview />;
  }

  const firstStep = steps[0];
  if (!firstStep) {
    return null;
  }
  return <Navigate to={WASTE_SUBMISSION_STEP_PRESENTATION[firstStep].routeSlug} replace />;
}
